export default __webpack_public_path__ + "static/media/mapping_card.71bb5491.jpg";